import { render, staticRenderFns } from "./Wirings.vue?vue&type=template&id=6bf5666c"
import script from "./Wirings.vue?vue&type=script&lang=js"
export * from "./Wirings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports